// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, require-jsdoc
export function guid() {
  return (
    random() +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    random() +
    random()
  );
}

// eslint-disable-next-line require-jsdoc
function random() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}
